<template>
  <div class="pulseiras-wrap" :class="[`pulseiras-${size}`, multi && 'pulseiras-multi']">
    <div v-if="multi && size === 'large'" class="pulseiras-multi-header">
      ⚠️ Entregar <strong>{{ pulseiras.length }} pulseiras</strong> — uma pra cada bloco de dias
    </div>

    <div
      v-for="(p, idx) in pulseiras"
      :key="p.key + '-' + idx"
      class="pulseira"
      :class="[`pulseira-${size}`]"
      :style="{ background: p.hex, color: p.textColor }"
      role="status"
      :aria-label="`Pulseira ${p.label}`"
    >
      <template v-if="size === 'small'">
        <span class="pulseira-icon-sm" aria-hidden="true">{{ p.icon }}</span>
        <div class="pulseira-text-sm">
          <strong>PULSEIRA {{ p.label.toUpperCase() }}</strong>
          <span>{{ p.usoLabel }}</span>
        </div>
      </template>

      <template v-else>
        <span class="pulseira-icon-lg" aria-hidden="true">{{ p.icon }}</span>
        <div class="pulseira-text-lg">
          <span class="pulseira-eyebrow">Pulseira</span>
          <strong class="pulseira-label-lg">{{ p.label.toUpperCase() }}</strong>
          <span class="pulseira-action">{{ p.usoLabel }}</span>
        </div>
      </template>
    </div>

    <div v-if="size === 'large'" class="pulseiras-footer">
      Entregar agora e botar no braço
    </div>
  </div>
</template>

<script>
import { pulseirasAcampante } from '../lib/pulseira'

export default {
  name: 'PulseiraBadge',
  props: {
    acampante: { type: Object, default: null },
    size: { type: String, default: 'small', validator: v => ['small', 'large'].includes(v) }
  },
  computed: {
    pulseiras() { return pulseirasAcampante(this.acampante) },
    multi() { return this.pulseiras.length > 1 }
  }
}
</script>

<style scoped>
.pulseiras-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.pulseiras-large.pulseiras-multi {
  background: #fff8e1;
  border: 2px solid #f59e0b;
  border-radius: var(--radius-lg);
  padding: 12px;
}
.pulseiras-multi-header {
  font-size: 13px;
  font-weight: 700;
  color: #7a4f01;
  text-align: center;
  padding: 4px 8px 8px;
  border-bottom: 1px dashed #f59e0b;
  margin-bottom: 4px;
}
.pulseiras-footer {
  font-size: 12px;
  font-weight: 700;
  color: var(--color-text-secondary);
  text-align: center;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.pulseira {
  display: flex;
  align-items: center;
  gap: 14px;
  border-radius: var(--radius-lg);
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* Listras decorativas no fundo (tecido de pulseira) */
.pulseira::before {
  content: '';
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.08) 0,
    rgba(255, 255, 255, 0.08) 12px,
    transparent 12px,
    transparent 24px
  );
  pointer-events: none;
}

/* SMALL — faixa horizontal */
.pulseira-small {
  padding: 10px 14px;
  min-height: 56px;
}
.pulseira-icon-sm {
  font-size: 26px;
  flex-shrink: 0;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.pulseira-text-sm {
  display: flex;
  flex-direction: column;
  gap: 2px;
  z-index: 1;
}
.pulseira-text-sm strong {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 1px;
  line-height: 1.1;
}
.pulseira-text-sm span {
  font-size: 11px;
  opacity: 0.92;
  font-weight: 500;
}

/* LARGE — bloco destacado */
.pulseira-large {
  flex-direction: column;
  text-align: center;
  padding: 20px 18px;
  min-height: 140px;
  justify-content: center;
  gap: 4px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
}
.pulseira-icon-lg {
  font-size: 52px;
  line-height: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  z-index: 1;
}
.pulseira-text-lg {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  z-index: 1;
}
.pulseira-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: 0.85;
}
.pulseira-label-lg {
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 2px;
  line-height: 1.05;
  margin: 2px 0 4px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.pulseira-action {
  font-size: 13px;
  font-weight: 600;
  opacity: 0.95;
  line-height: 1.4;
}

@media (max-width: 420px) {
  .pulseira-label-lg { font-size: 22px; }
  .pulseira-icon-lg { font-size: 44px; }
}
</style>
